<template>
    <div class="add-moderator">
        <form ref="create-moderator" @submit.prevent="createModerator()">
            <div class="form-name">Створити модератора</div>
            
            <div class="form-group">
                <label class="text" for="login">Login:</label>
                <input id="login" class="string" :class="errors.loginAlreadyExist ? 'error' : ''" type="text" v-model="login" @input="errors.loginAlreadyExist = false" required>

                <div class="error-text" v-if="errors.loginAlreadyExist">Цей логін вже використовується у системі</div>
            </div>

            <div class="form-group">
                <label class="text" for="password">Password:
                    <button type="button" class="password-generate" @click="generatePassword()">Згенерувати</button>
                </label>
                <input id="password" class="string" type="text" v-model="password" required>
            </div>

            <div class="form-group">
                <label class="text" for="event">Подія:</label>
                <select class="select" name="event" id="event" v-model="selectedEvent" required>
                    <option></option>
                    <option v-for="(e, index) in events" :key="index" :value="e">{{e.name}}</option>
                </select>
            </div>
            
            <div class="form-group buttons">
                <button type="submit" class="btn create">Створити</button>
                <button type="reset" class="btn reset">Скинути</button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data : () => ({
        login : '',
        password : '',
        events : [],
        selectedEvent : null,
        errors: {
            loginAlreadyExist : false
        }
    }),
    mounted(){
        axios.interceptors.request.use((config) => {
            var token = sessionStorage.getItem('access_token');
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        });

        axios.get(location.protocol + '/api/Admin/GetEvents')
        .then(response => {
            this.events = response.data;            
        })
    },
    methods : {
        generatePassword(){
            this.password = Math.random().toString(36).slice(-8);
        },
        createModerator(){
            let data = new FormData();

            data.append('login', this.login);

            axios.interceptors.request.use((config) => {
                var token = sessionStorage.getItem('access_token');
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            });

            axios.post(location.protocol + '/api/Admin/CheckLogin', data)
            .then(response => {
                console.log(response);

                let moderator = {
                    login : this.login,
                    password : this.password,
                    event : this.selectedEvent
                }

                console.log(moderator);

                axios.post(location.protocol + '/api/Admin/CreateModerator', moderator)
                .then(response => {
                    console.log(response);
                    this.$refs['create-moderator'].reset();
                })
            })
            .catch(e => {
                if (e.response.status === 400) {
                    this.errors.loginAlreadyExist = true;
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import '../../../assets/style/form.scss';

.add-moderator{
    padding: 40px 60px;
}

.password-generate{
    margin-left: 20px;
    cursor: pointer;
}
</style>